import { useEffect } from "react";

/**
 * Adjusts #content-region top to account for header + announcement height.
 * Matches Marionette's App.Views.Announcements.setContentTop().
 *
 * In the layout, #announcement-region and #header-region are in normal flow,
 * but #content-region is position:absolute with a fixed CSS top ($height-header).
 * When announcements are present, the header is pushed down and content-region
 * needs its top recalculated.
 */
export function useContentTop() {
  useEffect(() => {
    function adjustTop() {
      const contentRegion = document.getElementById("content-region");
      if (!contentRegion) return;
      const headerRegion = document.getElementById("header-region");
      const announcementRegion = document.getElementById("announcement-region");
      const top = (headerRegion ? headerRegion.offsetHeight : 0) +
        (announcementRegion ? announcementRegion.offsetHeight : 0);

      contentRegion.style.top = top > 0 ? `${top}px` : "";
    }

    const id = requestAnimationFrame(adjustTop);
    window.addEventListener("resize", adjustTop);

    const observer = new MutationObserver(() => {
      requestAnimationFrame(adjustTop);
    });

    const resizeObserver = typeof ResizeObserver === "function"
      ? new ResizeObserver(() => requestAnimationFrame(adjustTop))
      : null;

    const announcementRegion = document.getElementById("announcement-region");
    const headerRegion = document.getElementById("header-region");

    if (announcementRegion) {
      observer.observe(announcementRegion, { childList: true, subtree: true });
      resizeObserver?.observe(announcementRegion);
    }

    if (headerRegion) resizeObserver?.observe(headerRegion);

    return () => {
      cancelAnimationFrame(id);
      window.removeEventListener("resize", adjustTop);
      observer.disconnect();
      resizeObserver?.disconnect();
      const contentRegion = document.getElementById("content-region");
      if (contentRegion) contentRegion.style.top = "";
    };
  }, []);
}
